"use client";

import React from "react";
import type { WebDictionary, WebLocale } from "./locales";
import { getDictionary } from "./locales";

const LocaleContext = React.createContext<{
  locale: WebLocale;
  t: WebDictionary;
}>({ locale: "en", t: getDictionary("en") });

export function LocaleProvider({
  locale,
  children,
}: {
  locale: WebLocale;
  children: React.ReactNode;
}) {
  const value = React.useMemo(
    () => ({ locale, t: getDictionary(locale) }),
    [locale],
  );
  return (
    <LocaleContext.Provider value={value}>{children}</LocaleContext.Provider>
  );
}

export function useLocale() {
  return React.useContext(LocaleContext);
}
